import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	SharedGenerateAiPetitionImage,
	type SharedGenerateAiPetitionImageMutation,
	type SharedGenerateAiPetitionImageMutationVariables,
} from './generateAiPetitionImage.graphql';

type Input = { mainPrompt: string; personalStory?: string };

export async function generateAiPetitionImage(
	input: Input,
	utilityContext: UtilityContext,
): Promise<{ responseId: string } | null> {
	const {
		gql: { fetch },
		errorReporter,
	} = utilityContext;

	try {
		const { data } = await fetch<SharedGenerateAiPetitionImageMutation, SharedGenerateAiPetitionImageMutationVariables>(
			{
				query: SharedGenerateAiPetitionImage,
				path: '/generate-ai-petition-image',
				variables: {
					input: {
						title: input.mainPrompt,
						description: input.personalStory ?? '',
						backgroundMode: true,
					},
				},
				rejectOnError: true,
			},
		);

		if (data.generateAiPetitionImage.__typename !== 'GenerateAiPetitionImageBackgroundSuccess') return null;

		return { responseId: data.generateAiPetitionImage.responseId };
	} catch (error: unknown) {
		void errorReporter.report({
			error: error instanceof Error ? error : new Error('generate_ai_petition_image_failed'),
		});
		return null;
	}
}
